<script>
export default {
  methods: {
    checkIfLoggedIn() {
      if (!this.$store.state.keycloak.userObject) {
        this.$router.push({ name: 'Home' });
      }
    },
    translate(fieldToTranslate) {
      //console.log('---->' , fieldToTranslate);
      if (fieldToTranslate != undefined) {
        if (fieldToTranslate[this.$store.state.config.selectedLanguage] != undefined) {
          return fieldToTranslate[this.$store.state.config.selectedLanguage];
        } else {
          return fieldToTranslate[this.$store.state.config.defaultLanguage];
        }
      }
    },
    translateFormLang(fieldToTranslate) {
      if (fieldToTranslate != undefined) {
        if (fieldToTranslate[this.$store.state.config.submitFormLanguage] != undefined) {
          return fieldToTranslate[this.$store.state.config.submitFormLanguage];
        }
      }
    },
  },
};
</script>
